/* eslint-disable promise/param-names */
import Vue from 'vue'
import axios from 'axios'
import {
  GET_LANGUAGES_ERROR,
  GET_LANGUAGES_REQUEST,
  GET_LANGUAGES_SUCCESS, SWITCH_LANGUAGE_ERROR,
  SWITCH_LANGUAGE_REQUEST, SWITCH_LANGUAGE_SUCCESS
} from './actiontypes';
import translationApi from '../../_services/api/translation';
import {USER_REQUEST} from "../user/actiontypes";

const state = {
  languages: {},
  language: {},
  status: '',
  errors: [],
  hasLoadedOnce: false,
};

const getters = {
  languages: state => state.languages,
};

const actions = {
  [GET_LANGUAGES_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_LANGUAGES_REQUEST);
      translationApi.getLanguages()
        .then((response) => {
          if (response.success === true) {
            commit(GET_LANGUAGES_SUCCESS, response.data);
            resolve(response);
          } else {
            commit(GET_LANGUAGES_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(GET_LANGUAGES_SUCCESS, error);
          reject(error);
        });
    });
  },
  [SWITCH_LANGUAGE_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(SWITCH_LANGUAGE_REQUEST);
      translationApi.switchLanguage(payload)
          .then((response) => {
            if (response.success === true) {
              commit(SWITCH_LANGUAGE_SUCCESS, response.data);
              dispatch(USER_REQUEST);
              resolve(response);
            } else {
              commit(SWITCH_LANGUAGE_ERROR, response);
              reject(response.error);
            }
          })
          .catch((error) => {
            commit(SWITCH_LANGUAGE_ERROR, error);
            reject(error);
          });
    });
  },
};

const mutations = {
  [GET_LANGUAGES_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_LANGUAGES_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'languages', response.languages);
  },
  [GET_LANGUAGES_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [SWITCH_LANGUAGE_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [SWITCH_LANGUAGE_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'language', response.language);
  },
  [SWITCH_LANGUAGE_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
